export default __webpack_public_path__ + "static/dan-running-4261b935ff3200deaf490db3d00e901e.jpg";